module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Custom option template")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "Fav No Man’s Sky path",
      "label": "title",
      "track-by": "title",
      "options": _vm.options,
      "option-height": 120,
      "custom-label": _vm.customLabel,
      "show-labels": false
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.hname))]), _vm._v(" "), _c('span', {
          staticClass: "option__small"
        }, [_vm._v(_vm._s(props.option.hno))]), _vm._v(" "), _c('span', {
          staticClass: "option__small"
        }, [_vm._v(_vm._s(props.option.phone))])])]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("暂无搜索结果")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60cbf77c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NB/testMultSelect.vue
// module id = 1761
// module chunks = 1